import { render, staticRenderFns } from "./goods-edit.vue?vue&type=template&id=41e7dd96&scoped=true"
import script from "./goods-edit.vue?vue&type=script&lang=js"
export * from "./goods-edit.vue?vue&type=script&lang=js"
import style0 from "./goods-edit.vue?vue&type=style&index=0&id=41e7dd96&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e7dd96",
  null
  
)

export default component.exports